import { BaseService } from '../base';

export type InstallmentType = {
  code: string;
  productCode: string;
  description: string;
  productVersion: string;
  installmentPeriodCount: number;
};

export type InstallmentTypesResponse = InstallmentType[];

export type ProductType = 'HOME_INSURANCE' | string; // Permite outros tipos de produto

export class InstallmentTypesService extends BaseService {
  async getInstallmentTypes(productType: ProductType): Promise<{
    success: boolean;
    data?: InstallmentTypesResponse;
    error?: string;
  }> {
    try {
      const path = `/portal/v1/services/installment-type/${productType}`;
      const response = await this.get(path, {}, import.meta.env.VITE_API_URL);

      return await this.handleJsonResponse<InstallmentTypesResponse>(response);
    } catch (error) {
      return {
        success: false,
        error:
          error instanceof Error
            ? error.message
            : 'Erro ao carregar tipos de parcelamento',
      };
    }
  }

  async getBusinessInstallmentTypes(): Promise<{
    success: boolean;
    data?: InstallmentTypesResponse;
    error?: string;
  }> {
    try {
      const path = `/portal/v1/services/business-installment-type`;
      const response = await this.get(path, {}, import.meta.env.VITE_API_URL);

      return await this.handleJsonResponse<InstallmentTypesResponse>(response);
    } catch (error) {
      return {
        success: false,
        error:
          error instanceof Error
            ? error.message
            : 'Erro ao carregar tipos de parcelamento',
      };
    }
  }
}

export const installmentTypesService = new InstallmentTypesService();
